export default class RedirectPresenter {
  init = (settings) => {
    const customizerContainer = document.querySelector('#zakeke-container');
    if(!customizerContainer) return;

    this.customer = settings.customer_id ? settings.customer_id : null;

    if(sessionStorage.getItem('loginRedirect')) {
      sessionStorage.removeItem('loginRedirect');
    } else {
      this._waitForElement('#zakeke-frame').then((element) => {
        this._setRedirect();
      });
    }
  }

  _setRedirect() {
    if(!this.customer) {
      sessionStorage.setItem('loginRedirect', window.location.href);
    }
  }

  _waitForElement(selector) {
    return new Promise(function(resolve, reject) {
      const element = document.querySelector(selector);

      if(element) {
        resolve(element);
        return;
      }
  
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          const nodes = Array.from(mutation.addedNodes);
          for(var node of nodes) {
            if(node.matches && node.matches(selector)) {
              observer.disconnect();
              resolve(node);
              return;
            }
          };
        });
      });
  
      observer.observe(document.documentElement, { childList: true, subtree: true });
    });
  }
}